import { Injectable } from '@angular/core';

import { ApplicationAdapter } from 'application/application.adapter';
import { ModuleQuestionOutput } from 'module/model/page/question/module-question.output';
import { ModuleQuestionField } from 'module/page/question/field/module-question-field';
import { ModuleQuestionFieldI18n } from 'module/page/question/field/module-question-field-i18n';
import { ModuleQuestion } from 'module/page/question/module-question';
import { ModuleQuestionI18n } from 'module/page/question/module-question-i18n';
import { ModuleQuestionConverterPort } from 'module/page/question/port/module-question-converter.port';

@Injectable()
export class ModuleQuestionConverterAdapter
	extends ApplicationAdapter
	implements ModuleQuestionConverterPort
{
	public asModuleQuestion(output: ModuleQuestionOutput): ModuleQuestion {
		if (!output) {
			return null;
		}

		return new ModuleQuestion(
			output.id,
			output.name,
			output.position,
			output.condition,
			output.uniqFilter,
			output.canDuplicate,
			output.canAddSibling,
			output.sourceModuleId,
			output.updateTimestamp,
			output.sourceQuestionId,
			output.type,
			(output.fields || []).map(
				(field) =>
					new ModuleQuestionField(
						field.id,
						field.name,
						field.value,
						field.position,
						field.minLines,
						field.condition,
						field.gridClass,
						field.isRequired,
						field.isExtraField,
						field.optionsGroup,
						field.optionsScript,
						field.updateTimestamp,
						field.optionsGridClass,
						field.type,
						(field.localizations || []).map(
							(loc) =>
								new ModuleQuestionFieldI18n(loc.label, loc.locale, loc.placeholder)
						)
					)
			),
			(output.localizations || []).map(
				(loc) =>
					new ModuleQuestionI18n(
						loc.locale,
						loc.question,
						loc.addSiblingLabel,
						loc.addDuplicateLabel
					)
			),
			output.cssClass,
			output.gridClass
		);
	}
}
